import is from 'typescript-styled-is'
import styled from '../../../theme'
import Input from './Input'

const Textarea = styled(Input.withComponent('textarea') as any)<ITextareaProps>`
  min-height: ${({ size }) => (size ? 90 * size : 90)}px;
  line-height: ${({ size }) => (size ? 20 * size : 20)}px;
  ${is('autoSize')`
    height: unset;
    max-height: ${props =>
      props.autoSizeMaxHeight ? props.autoSizeMaxHeight : 242}px;
    resize: none
  `}
`

export default Textarea

export interface ITextareaProps {
  selected?: boolean
  error?: boolean
  warning?: boolean
  size?: number
  autoSize?: boolean
  minHeight?: number
  autoSizeMaxHeight?: number
}
